<mat-accordion class="custom-scrollbar menu">
  @for (menu of dataService.modulesUser; track menu.name; let i = $index) {
    @if (menu.name !== 'Inicio' && menu.submodules.length > 0) {
      @if ( isFirstModule(i) ){
        <mat-card appearance="outlined" style="border: solid 1px white;">
          <mat-card-header>
            <mat-card-subtitle style="color: black">{{'menu.'+menu.platform | translate}}</mat-card-subtitle>
          </mat-card-header>
        </mat-card>
      }

      <mat-expansion-panel class="textoNoWrap" style="display: unset;" hideToggle (opened)="arrowState[i] = 'keyboard_arrow_up'" (closed)="arrowState[i] = 'keyboard_arrow_down'">
        <mat-expansion-panel-header [ngClass]="isActivateModule(menu)?'header-select':'header'">
          <mat-panel-title class="title-flex">
            {{ 'menu.' + menu.name | translate }}
          </mat-panel-title>
          <mat-icon class="suffix-icon iconoMen" style="color: grey;">{{arrowState[i]}}</mat-icon>
        </mat-expansion-panel-header>
        @for (submenu of menu.submodules; track submenu.name) {
          <div style="padding-top: 2px; margin-left: -15%;" [ngClass]="isActiveSubmodule(submenu)?
          'sub-header-select':'sub-header'" class="textoNoWrap">
            <a (click)="sendTo(submenu)" style="cursor: pointer;">{{'menu.'+submenu.name | translate}}</a>
          </div>
        }
        @if (arrowState[i] == 'keyboard_arrow_up') {
          <div class="w3-menu-barrita">
            <div style="width: 19px; border: .2pt solid #616161; margin-top: 10px; margin-right: 10px;"></div>
          </div>
        }
      </mat-expansion-panel>
    }
  }@empty {
  no hay nada   
  }
</mat-accordion>
